import { FieldProps } from 'formik';
import { get } from 'lodash';
import * as React from 'react';
import { ChangeEvent } from 'react';
import TextInput from '../TextInput/TextInput';

interface IOwnProps {
  id: string;
  name: string;
  type: 'number' | 'text' | 'password' | 'hidden' | 'tel' | 'email';
  defaultValue: string;
  onChange: (event: ChangeEvent<any>) => void;
}

const InputField: React.SFC<FieldProps<any> & IOwnProps> = ({
  field,
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  ...props
}) => {
  return (
    <TextInput
      {...field}
      {...props}
      touched={get(touched, field.name)}
      errors={get(errors, field.name)}
      onChange={(event: ChangeEvent<any>) => {
          if (props.onChange) {
            props.onChange(event);
          }
          field.onChange(event);
      }}
    />
  );
};

export default InputField;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/InputField/InputField.tsx